import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		identity: 0,  // 0未认证  2：房主认证  20：待审核 
		userInfo: {
			cardId: '',
			headimgUrl: '',
			houses: [],
			nickname: '',
			phone: '',
			trueName: ''
		},
		houseId: '',//当前用户选中的房屋
		address: '',//当前用户地址
		isactive: false,
	},
	mutations: {
		changeIdentity(state, val) {
			state.identity = val;
			sessionStorage.setItem('identity', val);
		},
		emitactive(state, val) {
			state.isactive = val;
		},
		f(a) {
			if (isNaN(Number(a, 10))) {
				return false
			}
			else {
				return true
			}
		},
		changeUserinfo(state, obj) {
			state.userInfo = obj;
			state.userInfo.houses.map(item => {
				if (item.isDefault) {
					state.houseId = item.houseId;
					sessionStorage.setItem('houseId', item.houseId)
					var addarr = item.address.split(' ')
					var addstr = ''
					addarr.forEach((option, index) => {
						var na = ''
						if (index == 0 && !isNaN(Number(option, 10))) {
							na = option + '栋'
						} else if (index == 1 && !isNaN(Number(option, 10))) {
							na = option + '单元'
						} else if (index == 2 && !isNaN(Number(option, 10))) {
							na = option + '楼'
						} else if (index == 3 && !isNaN(Number(option, 10))) {
							na = option + '室'
						} else {
							na = option
						}
						addstr += na
					})
					state.address = item.communityName + item.address;
					state.addstr = item.communityName + addstr
					sessionStorage.setItem('currentHouseUserType', item.userType)
				}

			})
		},
	},
	actions: {

	}
	// this.$store.dispatch('Login',this.form)
	// this.$store.commit("changeSpace",)
})


export default store;
